webpackJsonp([250632767232615],{

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.arizonaImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArizonaLocation = function (_React$Component) {
	  _inherits(ArizonaLocation, _React$Component);
	
	  function ArizonaLocation() {
	    _classCallCheck(this, ArizonaLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ArizonaLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Arizona' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Promoting Ridership',
	        title: 'Clear Eyes, Open Streets, Can\'t Lose',
	        story: 'We revere events that appeal to all types of bike riders, which is why one of our favorite trips of the year was a visit to Tucson for Ciclovia, their open streets event. Tucson is one of our 10 Big Jump Cities, and the 2017 Ciclovia featured a longer (four-mile) route along a big commercial street. More than 25,000 people showed up to pedal or walk\u2014their best attended event to date.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Arizona 1-2',
	        alt: 'Ciclovia event in Tucson',
	        sizes: this.props.data.arizonaOneTwoImage.sizes
	      }),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Bike Biz',
	        title: 'New Partners for New Business',
	        story: 'PeopleForBikes\u2019 president Tim Blumenthal moderated a panel session at the Independent Bicycle Dealers (IBD) Summit in Tempe. The focus was on new paths to better business for bicycle retailers. Panelists discussed partnerships with the mass market segment of the bike business, the importance of big recreational bike rides, and the potential of bike sharing to get more people riding.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Arizona 2-1',
	        alt: 'People for Bikes at the Independent Bicycle Dealers (IBD) Summit in Tempe',
	        sizes: this.props.data.arizonaTwoOneImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Wichita, KS',
	        prevLocationPath: 'wichita',
	        prevLocationImgPath: this.props.data.arizonaPrevImage,
	        nextLocationName: 'Albany, NY',
	        nextLocationPath: 'albany',
	        nextLocationImgPath: this.props.data.arizonaNextImage
	      })
	    );
	  };
	
	  return ArizonaLocation;
	}(_react2.default.Component);
	
	exports.default = ArizonaLocation;
	
	// GraphQL query
	
	var arizonaImageQuery = exports.arizonaImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-arizona-js-7c6710fc18108057deee.js